import * as React from 'react'
import './index.css'
import {objToArray, getLength, IndexString} from '../../util'
import {Button} from 'antd'

class SearchPerson extends React.Component<any, any> {
    constructor(props: any) {
        super(props)
        this.state = {
            showMore: false,
            current: -1,
            source: ['baidu', 'google']
        }
    }

    loadMore(index: any, bool: boolean) {
        this.setState(
            {
                showMore: bool,
                current: index
            }
        )
    }

    judgeSource(url: string) {
        let arr = [{url: 'wenku', name: '百度文库'}, {url: 'doc88', name: '道客巴巴'}]
        let name = ''
        for (let i = 0; i < arr.length; i++) {
            if (IndexString(arr[i].url, url)) {
                name = arr[i].name
            }
        }
        return name
    }

    filterEmail(email: string) {
        let arr = ['service@', 'info@', 'news@', 'emuchnet@', 'webmaster@', 'bd@', 'media@', 'shantupian@', 'copyright@', 'kefu@']
        let state = true
        for (let i = 0; i < arr.length; i++) {
            if (IndexString(arr[i], email)) {
                state = false
            }
        }
        return state
    }

    highLight(text: any, name: any){
       const arr = name.split(' ');
       let temp = ''
        for(let i = 0; i < arr.length; i++){
            for(let j = 0; j < text.split(arr[i]).length; j++){
                temp +=  text.split(arr[i])[j] + '<i>' + arr[i] +'</i>'
            }
        }
      return (
          <span dangerouslySetInnerHTML={{__html: temp}} />
      )
    }

    render() {
        const {queryPerson, name} = this.props
        const showMore = this.state.showMore
        const current = this.state.current
        return (
            <div>
                {
                    queryPerson && objToArray(queryPerson).length > 0 &&
                    objToArray(queryPerson).map((person: any, index: any) =>
                        (person.contact.mobile_number || person.contact.phone_number || (person.contact.email_address && this.filterEmail(person.contact.email_address))) &&
                        <div className="timeline" key={index}>
                            <div className="column">
                                <div className="container-fluid well span6">
                                    <div className="row-fluid">
                                        <div className="span2">
                                            <img
                                                src={person.contact.image_url ? person.contact.image_url : require('./img/searchUser.svg')}
                                                className="img-circle"/>
                                        </div>
                                        <div className="span8">
                                            <h3><strong>搜索条目：</strong> {name}
                                            </h3>
                                            {person.contact.email_address && this.filterEmail(person.contact.email_address) &&
                                            <h6><strong>Email:</strong> {person.contact.email_address}</h6>
                                            }
                                            {
                                                person.contact.mobile_number &&
                                                <h6><strong>手机:</strong> {person.contact.mobile_number}</h6>
                                            }
                                            {
                                                person.contact.phone_number &&
                                                <h6><strong>电话:</strong> {person.contact.phone_number}</h6>
                                            }
                                            {
                                                showMore && current === index ?
                                                    person.full_text &&
                                                    <h6><a onClick={() => this.loadMore(index, false)}>收起... </a></h6>
                                                    :
                                                    person.full_text && <h6>
                                                        <span><strong>搜索结果详情：</strong> {getLength(person.full_text) > 30 ? person.full_text.substr(0, 30) : person.full_text.substr(0, getLength(person.full_text))}</span>
                                                        <a className="link-more" onClick={() => this.loadMore(index, true)}>更多详情... </a>
                                                    </h6>
                                            }
                                        </div>
                                        <div className="span2 operation">
                                            <div className="dropDownMenu">
                                                <Button className="item none-button-border">
                                                    <a href={Object.keys(queryPerson)[index]}
                                                       target="_blank">原文链接
                                                        <i className="fa fa-external-link"/>
                                                    </a>
                                                </Button>
                                            </div>
                                        </div>
                                        <div className="source-box">
                                            <div className="source-item">
                                                {this.judgeSource(Object.keys(queryPerson)[index]) &&
                                                <div className="span2 article-source blue-color">
                                                    {this.judgeSource(Object.keys(queryPerson)[index])}
                                                </div>
                                                }
                                            </div>
                                            <div className="source-item">
                                                {person.sources && person.sources.map(
                                                    (item: any, index: number) =>
                                                        <div className="span2 article-source yellow-color">
                                                            {item}
                                                        </div>
                                                )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    showMore && current === index &&
                                    <div className="description">
                                        <p>搜索结果详情：{this.highLight(person.full_text, name)}</p>
                                    </div>
                                }
                            </div>
                        </div>
                    )
                }
            </div>
        )
    }
}

export default SearchPerson



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SearchPerson/index.tsx